import "../../_namespaces.js";
import "../../_generated_templates.js";
window.AssessmentViewer ??= {};
window.AssessmentViewer.Views ??= {};

AssessmentViewer.Views.AssessmentDone = class AssessmentDone extends Backbone.View {
  constructor() {
    super(...arguments);
    this.render = this.render.bind(this);
  }

  render() {
    this.$el.html(this.template({ text: this.model.get("text"), score: this.model.get("score") }));
    return this;
  }
};
AssessmentViewer.Views.AssessmentDone.prototype.tagName = "div";
AssessmentViewer.Views.AssessmentDone.prototype.className = "assessment-view assessment-view--done";
AssessmentViewer.Views.AssessmentDone.prototype.template = _.template(AssessmentViewer.Templates.Assessment.done);
